import { IconProps } from "types/icon"

const Mastercard = ({ size = "28", ...props }: IconProps) => {
  const height = Number(size)
  const width = height * (24 / 15)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 15"
      fill="none"
      aria-hidden
      {...props}
    >
      <circle cx="8.5" cy="7.5" r="6.5" fill="#EB001B" />
      <circle cx="15.5" cy="7.5" r="6.5" fill="#F79E1B" fillOpacity="0.95" />
      <path
        d="M12 3.4C10.6 4.5 9.7 6 9.7 7.5C9.7 9 10.6 10.5 12 11.6C13.4 10.5 14.3 9 14.3 7.5C14.3 6 13.4 4.5 12 3.4Z"
        fill="#FF5F00"
      />
    </svg>
  )
}

export default Mastercard
